<template lang="pug">
.supercharged-entertainment-container
  .page-unsubscribe
    .confirm__container
      template(v-if="unsubscribed")
        h3.h3.confirm__caption {{ successLabel }}
      template(v-else)
        h3.h3.confirm__caption Do you want to unsubscribe?
        .confirm__buttons
          a.site_button(href="#" @click.prevent="unsubscribe()")
            span Yes, unsubscribe
        re-toast-alert.m-t-20.m-b-20(v-if="errorMessage" type="danger") {{ errorMessage }}
    .block-ui(v-show="unsubscribing")
      .with-loader

</template>

<script>
import UnsubscribeButton from 'system/user/components/UnsubscribeButton/script.js'

export default {
  name: 'page-unsubscribe',

  props: {
    successLabel: {
      type: String,
      default: 'You have been unsubscribed.',
    },
  },

  mixins: [
    UnsubscribeButton,
  ],
}
</script>
